//Menú principal del landing page

//Imports 
import React from 'react';
import {Link} from 'react-router-dom';
import {Card, Col, Row, Button} from "antd";
import {UserOutlined, FormOutlined, ClockCircleOutlined, HistoryOutlined, SendOutlined,ScheduleOutlined} from '@ant-design/icons';
//import iconSolicitudPresencial from './img/Raster.png';
import 'antd/dist/antd.css';
import logoUChile from './img/visitas-tui-c.png';

const { Meta } = Card;

//HTML DEL COMPONENTE 
function Main() {
    return (
        <div>
            <Card style={{borderColor: "transparent"}} bodyStyle={{paddingTop: 0}}>
                <Row style={{backgroundColor: "#F3F7FC"}} height="197px">
                    <Col span={13}>
                        <div style={{color: "#116EC0", fontSize: 28, fontWeight: "bold", marginLeft: "10%", marginRight: "10%", marginTop: 20}}>Bienvenido al sistema de Visitas TUI</div>

                        <div style={{color: "#4B5660", fontSize: 15, marginLeft: "10%", marginRight: "10%"}}>En este sitio podrás ingresar todas las visitas que requieren acceso a las instalaciones de la Universidad. <br/> Además podrás revisar todos los estados de estas solicitudes, crear prorrogas y revisar información historica.</div>
                    </Col>
                    <Col span={11}>
                        <img src={logoUChile} alt="logo" align="center" width="100%"/>
                    </Col>
                </Row>
            </Card>
            <Card bodyStyle={{paddingTop: 0}} style={{backgroundColor: "transparent", borderColor: "transparent"}}>
                <Row style={{margin:"20px"}} gutter={[60, 10]}>
                    <Col span={8}>
                        <Card /* className='main-card' */ bodyStyle={{paddingTop: 0}} style={{borderRadius: "5px", backgroundColor: "transparent", borderColor: "transparent"}} >
                            <div style={{textAlign:"center"}}><UserOutlined className='main-icon' style={{color: "#0a5da6"}} /></div>
                            <div className='main-title'> <b>Mis Solicitudes</b></div>
                            <div className='main-description'>Verifica el estado de todas las solicitudes que se han realizado en tu unidad, para así
                            revisarlas. </div>
                            <div style={{textAlign:"center"}}> <button className='main-secundario-button ant-btn'><Link style={{color: "#116EC0"}} to='/myrequests'>ACCEDER</Link></button></div>
                        </Card>
                    </Col>
                    <Col span={8}>
                        <Card /*className='main-card'*/ bodyStyle={{paddingTop: 0}} style={{borderRadius: "5px", backgroundColor: "transparent", borderColor: "transparent"}}>
                            <div style={{textAlign:"center"}}><FormOutlined className='main-icon' style={{color: "#0a5da6"}} />{/* <img style={{width:"51px",height:"51px", backgroundColor:"#0A5DA6"}}src={iconSolicitudPresencial}/> */}</div>
                            <div className='main-title'> <b>Solicitud Presencial</b></div>
                            <div className='main-description'>Crea una nueva solicitud desde tu cuenta UChile. Esta solicitud quedará automáticamente
                            aprobada. </div>
                            <div style={{textAlign:"center"}}> <button className='main-secundario-button ant-btn'><Link style={{color: "#116EC0"}} to='/form'>ACCEDER</Link></button></div>
                        </Card>
                    </Col>
                    <Col span={8}>
                        <Card /*className='main-card'*/ bodyStyle={{paddingTop: 0}} style={{borderRadius: "5px", backgroundColor: "transparent", borderColor: "transparent"}}>
                            <div style={{textAlign:"center"}}><HistoryOutlined className='main-icon' style={{color: "#0a5da6"}} /></div>
                            <div className='main-title'> <b>Prórroga</b></div>
                            <div className='main-description'>Crea una prórroga desde tu cuenta UChile. Esta solicitud quedará automáticamente aprobada. </div>
                            <div style={{textAlign:"center"}}> <button className='main-secundario-button ant-btn'><Link style={{color: "#116EC0"}} to='/prorroga'>ACCEDER</Link></button></div>
                        </Card>
                    </Col>
                </Row>
                <Row style={{margin:"20px"}} gutter={[60, 10]}>
                    <Col span={8}>
                        <Card /*className='main-card'*/ style={{ borderRadius: "5px", backgroundColor: "transparent", borderColor: "transparent"}}>
                            <div style={{textAlign:"center"}}><ClockCircleOutlined className='main-icon' style={{color: "#0a5da6"}} /></div>
                            <div className='main-title'> <b>Histórico Visitas</b></div>
                            <div className='main-description'>Revisa información histórica sobre visitas. </div>
                            <div style={{textAlign:"center"}}> <button className='main-secundario-button ant-btn'><Link style={{color: "#116EC0"}} to='/historical'>ACCEDER</Link></button></div>
                        </Card>
                    </Col>
                    <Col span={8}>
                        <Card /*className='main-card'*/ style={{borderRadius: "5px", backgroundColor: "transparent", borderColor: "transparent"}}>
                            <div style={{textAlign:"center"}}><SendOutlined className='main-icon' style={{color: "#0a5da6"}} /></div>
                            <div className='main-title'> <b>Enviar Invitaciones</b></div>
                            <div className='main-description'>Envía invitaciones para que las visitas puedan rellenar formulario de información personal de
                            forma remota.</div>
                            <div style={{textAlign:"center"}}> <button className='main-secundario-button ant-btn'><Link style={{color: "#116EC0"}} to='/sendinvitations'>ACCEDER</Link></button></div>
                        </Card>
                    </Col>
                    <Col span={8}>
                        <Card /*className='main-card'*/ style={{borderRadius: "5px", backgroundColor: "transparent", borderColor: "transparent"}}>
                            <div style={{textAlign:"center"}}><ScheduleOutlined className='main-icon' style={{color: "#0a5da6"}} /></div>
                            <div className='main-title'> <b>Invitaciones Pendientes</b></div>
                            <div className='main-description'>Revisa las invitaciones enviadas que aún no han sido respondidas. </div>
                            <div style={{textAlign:"center"}}> <button className='main-secundario-button ant-btn'><Link style={{color: "#116EC0"}} to='/invites'>ACCEDER</Link></button></div>
                        </Card>
                    </Col>
                </Row>
            </Card>
        </div>
    );
}

export default Main;